import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { navConfig } from './navigation.config';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { basicLayoutFeature } from './state/reducers';
import { appFeature } from '../shared/state/reducers';
import { selectCurrentRoute, selectFirstChildRoute } from '../shared/state/selectors';
import { footerImages } from './constants/resource-images';
import { NavigationEnd, Router } from '@angular/router';
import { basicLayoutActions } from './state/actions';
import { ToastyService } from '../shared/services/toasty.service';
import { Toasty } from '../shared/models/toasty.interface';
import { ToastyTypes } from '../shared/constants/toasty-types.enum';

@Component({
    selector: 'app-basic-layout',
    templateUrl: './basic-layout.component.html',
    styleUrls: ['./basic-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BasicLayoutComponent implements OnInit, OnDestroy {
  menuItems = navConfig.menuItems;
  footerImages = footerImages;
  private routeSubscription!: Subscription;


  data$ = combineLatest({
    sidebarOpened: this.store.select(basicLayoutFeature.selectSidebarOpened),
    isSmallScreen: this.store.select(appFeature.selectIsSmallScreen),
    modalOpened: this.store.select(basicLayoutFeature.selectModalOpened),
    modalResource: this.store.select(basicLayoutFeature.selectModalResourceUrl),
    modalResourceType: this.store.select(basicLayoutFeature.selectModalResourceType),
    currentRoute: this.store.select(selectFirstChildRoute)
  });
  toasty$ = this.toastyService.toastyState;
  @ViewChild('pageContainer') pageContainer!: ElementRef;

  constructor(private store: Store, public router: Router, public toastyService: ToastyService) {}

  ngOnInit(): void {
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.store.dispatch(basicLayoutActions.setSidebarVisibility({ opened: false }));
        this.scrollToTop();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  scrollToTop(): void {
    if (this.pageContainer) {
      this.pageContainer.nativeElement.scrollTo({ top: 0  });
    }
  }

  closeModal() {
    this.store.dispatch(basicLayoutActions.closeModal());
  }

}
